module.exports = __webpack_public_path__ + "img/aliens-mouth.0ddd7bb3.png";